import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetSpecificRowAction = createAsyncThunk(
  "GetSpecificRowAction",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Action/GetSpecificRowById",
        parameters
      );

      const data = response.data.result;

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ActionReducer = createSlice({
  name: "ApplicationInfo",
  initialState: {
    ActionRow: {},
    loadingActionRow: false,
    errorActionRow: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetSpecificRowAction.pending, (state, action) => {
        state.loadingActionRow = true;
        state.ActionRow = action.payload;
        state.errorActionRow = null;
      })
      .addCase(GetSpecificRowAction.fulfilled, (state, action) => {
        state.loadingActionRow = false;
        state.ActionRow = action.payload;
      })
      .addCase(GetSpecificRowAction.rejected, (state, action) => {
        state.loadingActionRow = false;
        state.ActionRow = action.payload;
      });
  },
});
export default ActionReducer.reducer;
